//SET:4th
import { all } from "redux-saga/effects";
import CouponSagas from "./CouponSagas";

export default function* rootSaga(getState) {
	yield all([
		CouponSagas(),
	]);
}